@if (showTitle()) {
  <h3 class="latest-news-title">{{ sectionTitle() | translate }}</h3>
}

@for (news of data(); track news.id; let lastNews = $last) {
  <app-news-section
    [isLastNews]="lastNews"
    [showShortTitle]="showShortTitle()"
    [customDateField]="customDateField()"
    [news]="news"></app-news-section>
}

<app-see-all
  [showSeeAllButton]="showSeeAllButton()"
  [url]="HELPER.getUrlFromMenu(E_FOLDER_TYPES.News)"
  seeAllText="See all news">
</app-see-all>
